import React, { useRef, useState } from 'react'
import { Button, Dropdown, Stack } from 'react-bootstrap'
import { ArrowLeft, Trash3, BoxArrowUpRight } from 'react-bootstrap-icons'
import { useNavigate } from 'react-router'

import handshake from '../../../assets/icons/5c7afe00ced3c77617e06033_handshake-icon-p-800.png'
import clone from '../../../assets/icons/clone-icon-24.png'
import setPartArchivedStatus from '../../../modules/redux/partList/setPartArchivedStatus'
import setPartDeletedStatus from '../../../modules/redux/partList/SetPartDeletedStatus'
import setPartSoldStatus from '../../../modules/redux/partList/SetPartSoldStatus'
import setSellPartModal from '../../../modules/redux/partList/SetSellPartModal'
import { useDispatch } from '../../../modules/store/customDispatch'
import { Part } from '../../../types/part/partTypes'
import HoverOverlay from '../HoverOverlay/HoverOverlay'
import Loader from '../Loader/Loader'
import { adminRouteAlias, getAdminNavigationPath } from '../../../router/adminRouteAlias'

import styles from './styles.module.scss'

interface IProps {
    part: Part
    deleteOnly: boolean
    isSoldPartList?: boolean
}

const CellButtonsParts = ({ part, deleteOnly = false, isSoldPartList = false }: IProps) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const soldRef = useRef<HTMLButtonElement | null>(null)
    const [isLoadingClonePart, setIsLoadingClonePart] = useState(false)
    const soldDealsCount = (part.extraData?.soldDealsArr || []).length

    const handleClonePart = async () => {
        setIsLoadingClonePart(true)
        navigate(`/admin/newPart`, { state: { part } })
        setIsLoadingClonePart(false)
    }

    if (isSoldPartList) {
        return (
            <Stack direction="horizontal" gap={2}>
                <HoverOverlay tooltipText={'Вернуть из проданного'}>
                    <Button
                        variant="danger"
                        size="sm"
                        onClick={() =>
                            soldDealsCount > 0
                                ? navigate(`${getAdminNavigationPath(adminRouteAlias.deals.list)}?activeStage=all&search=${part.id}`)
                                : dispatch(setPartSoldStatus(part.id, false))
                        }
                        className="d-flex align-items-center"
                    >
                        <ArrowLeft color={'white'} size={18} />
                    </Button>
                </HoverOverlay>

                {/* <HoverOverlay tooltipText={'Вернуть из проданного'}>
                    <Button
                        variant="danger"
                        size="sm"
                        onClick={() => dispatch(setPartSoldStatus(part.id, false))}
                        className="d-flex align-items-center"
                    >
                        <ArrowLeft color={'white'} size={18} />
                    </Button>
                </HoverOverlay> */}
                {isLoadingClonePart ? (
                    <Loader diameterInPx={26} thicknessInPx={3} />
                ) : (
                    <HoverOverlay tooltipText={'Дублировать'}>
                        <Button
                            variant="secondary"
                            size="sm"
                            onClick={handleClonePart}
                            className="d-flex align-items-center"
                            style={{ margin: 0 }}
                        >
                            <img src={clone} alt="clone" className={styles.cloneIcon} />
                        </Button>
                    </HoverOverlay>
                )}
            </Stack>
        )
    }

    if (deleteOnly) {
        return (
            <HoverOverlay tooltipText={'Удалено'}>
                <Button
                    variant="danger"
                    size="sm"
                    onClick={() => dispatch(setPartDeletedStatus(part.id))}
                    className="d-flex align-items-center"
                >
                    <Trash3 color={'white'} size={18} />
                </Button>
            </HoverOverlay>
        )
    }

    return (
        <>
            <Dropdown>
                <Dropdown.Toggle variant="danger" size="sm" className="d-flex align-items-center">
                    <Trash3 color={'white'} size={14} />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    <HoverOverlay tooltipText={'Архивировано'}>
                        <Dropdown.Item eventKey="1" onClick={() => dispatch(setPartArchivedStatus(part.id))}>
                            В архив
                        </Dropdown.Item>
                    </HoverOverlay>
                    <HoverOverlay tooltipText={'Удалено'}>
                        <Dropdown.Item eventKey="2" onClick={() => dispatch(setPartDeletedStatus(part.id))}>
                            Удалить
                        </Dropdown.Item>
                    </HoverOverlay>
                </Dropdown.Menu>
            </Dropdown>
            <HoverOverlay tooltipText={'Продать'} preventWrapFullWidth>
                <Button
                    variant="success"
                    size="sm"
                    onClick={() => dispatch(setSellPartModal({ part, isOpen: true }))}
                    className="d-flex align-items-center"
                    ref={soldRef}
                >
                    {/* <Check color={'white'} size={18}/> */}
                    <img src={handshake} alt="handshake" className={styles.successBtn} />
                </Button>
            </HoverOverlay>
            <HoverOverlay tooltipText={'Открыть в новом окне'} preventWrapFullWidth>
                <Button
                    variant="secondary"
                    size="sm"
                    onClick={() => window.open(`/admin/parts/${part.id}`, '_blank', 'noopener,noreferrer')}
                    className="d-flex align-items-center"
                    style={{ marginLeft: 8 }}
                >
                    <BoxArrowUpRight color={'white'} size={14} />
                </Button>
            </HoverOverlay>
        </>
    )
}

export default CellButtonsParts
